import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'website_navigation',
  data: function data() {
    return {
      pageConfig: {
        editPageName: '官网导航',
        addFunName: 'websiteNavigationAdd',
        modifyFunName: 'websiteNavigationModify',
        delFunName: 'websiteNavigationDel',
        queryFunName: 'websiteNavigationQuery',
        treeFunName: 'websiteNavigationTree',
        detailFunName: 'websiteNavigationDetail',
        clearCacheFunName: 'websiteNavigationClearCache',
        dicTreeFunName: 'mngDictionaryLowerTree',
        switchFunName: 'mngSwitchCacheValue'
      },
      dicData: {
        upperCode: 'website_nav_category',
        configCategorys: [],
        configCategoryOptions: {}
      },
      navCodeAndDicsEditor: false,
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        userId: localStorage.getItem('userId'),
        upper: null,
        upperName: null,
        nameCn: null,
        nameEn: null,
        category: null,
        styleTemplate: null,
        topImage: null,
        listImage: null,
        tabImageBright: null,
        tabImageGray: null,
        content: null,
        videos: null,
        files: null,
        sort: null,
        navCode: null,
        useDics: null,
        dicNotBlank: true,
        codeNotBlank: true
      },
      rules: {
        name: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }],
        sort: [{
          pattern: /^[1-9]\d*$/,
          message: '排序号必须为正整数',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.upperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configCategorys = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configCategoryOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.switchFunName]('Website_Nav_CodeDic_Editor').then(function (res) {
        _this.navCodeAndDicsEditor = !!res.data;
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    refresh: function refresh() {
      var _this2 = this;
      this.$confirm('确定要刷新缓存吗').then(function () {
        _this2.$api[_this2.pageConfig.clearCacheFunName]().then(function (res) {
          _this2.$message.success('刷新成功');
        });
      });
    },
    article: function article(navigation) {
      this.$emit('child-go-article', navigation);
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      this.formData.dicNotBlank = !!paramData.useDics;
      this.formData.codeNotBlank = !!paramData.navCode;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    uploadListImage: function uploadListImage(_ref) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this3.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this3.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this3.formData.listImage = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeListImage: function removeListImage() {
      this.formData.listImage = '';
    },
    uploadTopImage: function uploadTopImage(_ref3) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref3.file;
              _this4.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this4.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this4.formData.topImage = _context3.sent;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    removeTopImage: function removeTopImage() {
      this.formData.topImage = '';
    },
    uploadTabImageBright: function uploadTabImageBright(_ref5) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref5.file;
              _this5.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this5.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this5.formData.tabImageBright = _context5.sent;
                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    removeTabImageBright: function removeTabImageBright() {
      this.formData.tabImageBright = '';
    },
    uploadTabImageGray: function uploadTabImageGray(_ref7) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var file;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              file = _ref7.file;
              _this6.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(res) {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return _this6.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this6.formData.tabImageGray = _context7.sent;
                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x4) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    removeTabImageGray: function removeTabImageGray() {
      this.formData.tabImageGray = '';
    },
    add: function add(upper, upperName) {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
      this.formData.upper = upper || 'GTY-QQ:409932398';
      this.formData.upperName = upperName || '顶级导航';
    },
    edit: function edit(id) {
      var _this7 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this7.initFormData(res.data);
        _this7.formData.upperName = _this7.formData.upperName || '顶级导航';
        _this7.editDialogTitle = _this7.pageConfig.editPageName + '维护';
        _this7.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this8 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this8.$api[_this8.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this8.$message.success('删除成功');
            _this8.query();
          } else {
            _this8.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this9 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.treeFunName](localStorage.getItem('userId'), this.searchForm).then(function (res) {
        _this9.tableData = res.data || [];
        _this9.totalCount = res.count;
        _this9.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this10 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this10.formData.id) {
            _this10.$api[_this10.pageConfig.modifyFunName](_this10.saveFormDataProcess(_this10.formData)).then(function (res) {
              if (res.data) {
                _this10.$message.success('编辑成功');
                _this10.initFormData(_this10.emptyFormData);
                _this10.editDialogShow = false;
                _this10.query();
              } else {
                _this10.$message.error('编辑失败');
              }
            });
          } else {
            _this10.$api[_this10.pageConfig.addFunName](_this10.saveFormDataProcess(_this10.formData)).then(function (res) {
              if (res.data) {
                _this10.$message.success('新增成功');
                _this10.initFormData(_this10.emptyFormData);
                _this10.editDialogShow = false;
                _this10.query();
              } else {
                _this10.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};